import Security from './security';
import Validator from './validator';

const _SECURE_MASK = 22;

class LocalStorage {

    static getItem(key) {
        try {
            if ('localStorage' in window && window.localStorage !== null && window.localStorage.length > 0) {
                return window.localStorage.getItem(key);
            }
        } catch (e) {
            console.error(e);
        }

        return undefined;
    }

    static setItem(key, value) {
        try {
            if ('localStorage' in window && window.localStorage !== null) {
                window.localStorage.setItem(key, value);
            }
        } catch (e) {
            console.error(e);
        }
    }

    static removeItem(key) {
        try {
            if ('localStorage' in window && window.localStorage !== null && window.localStorage.length > 0) {
                window.localStorage.removeItem(key);
            }
        } catch (e) {
            console.error(e);
        }
    }

    static removeAllItems(key) {
        try {
            if ('localStorage' in window && window.localStorage !== null) {
                window.localStorage.clear();
            }
        } catch (e) {
            console.error(e);
        }
    }

    static storeSecured(namespace, data) {
        if (typeof data !== 'string') {
            data = JSON.stringify(data);
        }

        var maskedData = Security.stringMask(data, _SECURE_MASK);
        this.setItem(namespace, Security.base64Encode(maskedData));
    }

    static getSecured(namespace) {
        var data = this.getItem(namespace);

        if (typeof data !== 'undefined') {
            data = Security.stringUnmask(Security.base64Decode(data), _SECURE_MASK);

            if (Validator.isJsonString(data)) {
                try {
                    data = JSON.parse(data);
                } catch (e) {
                    return data;
                }
            }
        }

        return data;
    }

}

class SessionStorage {

    static getItem(key) {
        try {
            if ('sessionStorage' in window && window.sessionStorage !== null && window.localStorage.length > 0) {
                return window.sessionStorage.getItem(key);
            }
        } catch (e) {
            console.error(e);
        }

        return undefined;
    }

    static setItem(key, value) {
        try {
            if ('sessionStorage' in window && window.sessionStorage !== null) {
                window.sessionStorage.setItem(key, value);
            }
        } catch (e) {
            console.error(e);
        }
    }

    static removeItem(key) {
        try {
            if ('sessionStorage' in window && window.sessionStorage !== null && window.localStorage.length > 0) {
                window.sessionStorage.removeItem(key);
            }
        } catch (e) {
            console.error(e);
        }
    }

    static removeAllItems() {
        try {
            if ('sessionStorage' in window && window.sessionStorage !== null) {
                window.sessionStorage.clear();
            }
        } catch (e) {
            console.error(e);
        }
    }

    static storeSecured(namespace, data) {
        if (typeof data !== 'string') {
            data = JSON.stringify(data);
        }

        var maskedData = Security.stringMask(data, _SECURE_MASK);
        this.setItem(namespace, Security.base64Encode(maskedData));
    }

    static getSecured(namespace) {
        var data = this.getItem(namespace);

        if (typeof data !== 'undefined') {
            data = Security.stringUnmask(Security.base64Decode(data), _SECURE_MASK);

            if (Validator.isJsonString(data)) {
                try {
                    data = JSON.parse(data);
                } catch (e) {
                    return data;
                }
            }
        }

        return data;
    }


}

export {
    LocalStorage,
    SessionStorage
};



// WEBPACK FOOTER //
// ./src/helpers/storage.js